module.exports = __webpack_public_path__ + "3c9a17c350db79944307e140da09e930.svg";